angular.module('impactx.cscontract').controller('CSContractRFQCDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    '$mdDialog',
    'ToolbarService',
    'TranslationService',
    CSContractRFQCDataCtrl
]);

function CSContractRFQCDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, $mdDialog, ToolbarService, TranslationService) {
    var self = this;
    $scope.showInactiveRfqc = false;

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/rfqc/view").then(function () {
        self.initToolbarButtons();
    });

    this.save = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/cscontract/rfqc/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            BackService.back();
        });
    };

    this.initToolbarButtons = function () {
        ToolbarService.setButtons([{
            label: TranslationService.get('save'), action: self.save, type: 'validation',
            params: {
                form: $scope.dialogData
            }
        }]);
    };
}